import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * DBCD (Convergência e Divergência de BIAS, FML.DBCD) — painel próprio,
 * 2 linhas: DBCD e MM. yAccessor(d) retorna { dbcd, mm }.
 */
class DBCDSeries extends Component {
  constructor(props) {
    super(props);
    this.dbcdAccessor = this.dbcdAccessor.bind(this);
    this.mmAccessor = this.mmAccessor.bind(this);
  }
  dbcdAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.dbcd;
  }
  mmAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.mm;
  }
  render() {
    const { strokeDbcd, strokeMm, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.dbcdAccessor}
          stroke={strokeDbcd}
          fill="none"
        />
        <LineSeries yAccessor={this.mmAccessor} stroke={strokeMm} fill="none" />
      </g>
    );
  }
}

DBCDSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeDbcd: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeMm: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

DBCDSeries.defaultProps = {
  strokeDbcd: { color: "#FFFF00" },
  strokeMm: { color: "#FF0000" },
  className: "react-stockcharts-dbcd-series",
};

export default DBCDSeries;
